<template>
    <div class="google-reviews-container">
        <!-- Loading State -->
        <div v-if="loading" class="tw-flex tw-items-center tw-py-4">
            <div
                class="tw-animate-spin tw-rounded-full tw-h-4 tw-w-4 tw-border-b-2 tw-border-stinging-yellow tw-mr-2"></div>
            <span class="tw-text-sm tw-text-grey-300">Loading reviews...</span>
        </div>

        <!-- Reviews Display -->
        <a
            v-else
            :href="reviewUrl"
            target="_blank"
            class="tw-block tw-pt-2 tw-pb-6 hover:tw-opacity-80 tw-transition-opacity"
            :aria-label="displayText"
        >
            <div class="tw-flex tw-items-center">
                <div class="tw-flex tw-items-center">
                    <StarIcon
                        v-for="(starType, index) in starTypes"
                        :key="`star-${index}`"
                        :type="starType"
                        :index="index"
                    />
                </div>
                <span class="tw-ms-1 tw-text-sm tw-font-bold tw-text-grey-300">Google</span>
                <span class="tw-ms-1 tw-text-sm tw-font-bold tw-text-grey-400">{{ rating }}</span>
            </div>
        </a>
    </div>
</template>

<script>
import StarIcon from './StarIcon.vue';

export default {
    name: 'GoogleReviews',
    components: {
        StarIcon
    },
    props: {
        reviewUrl: {
            type: String,
            default: 'https://g.co/kgs/aVztW6g',
        },
        apiEndpoint: {
            type: String,
            default: '/api/google-reviews'
        },
    },
    data() {
        return {
            loading: false,
            maxStars: 5,
            rating: null,
            // reviewUrl,
            // reviewCount,
        };
    },
    computed: {
        formattedRating() {
            return this.rating?.toFixed(1);
        },
        displayText() {
            return `Google Reviews: ${this.formattedRating} out of ${this.maxStars} stars`;
        },
        starTypes() {
            const stars = Array(this.maxStars).fill('empty');
            const fullStars = Math.floor(this.rating);
            const remainder = this.rating - fullStars;

            // Fill full stars
            for (let i = 0; i < fullStars; i++) {
                stars[i] = 'full';
            }

            // Handle partial stars, >= 0.75 => full star; 0.25 - 0.74 => half star; 0 - 0.24 => empty star
            if (fullStars < this.maxStars) {
                if (remainder >= 0.75) {
                    stars[fullStars] = 'full';
                } else if (remainder >= 0.25) {
                    stars[fullStars] = 'half';
                }
            }

            return stars;
        },
    },
    async created() {
        if (!this.rating) {
            await this.fetchReviewData();
        }
    },
    methods: {
        async fetchReviewData() {
            this.loading = true;

            try {
                const response = await fetch(this.apiEndpoint);

                if (!response.ok) {
                    throw new Error(`HTTP ${response.status}: ${response.statusText}`);
                }

                const {status, result} = await response.json();

                if (status === 'OK' && result) {
                    this.rating = Number(result.rating);
                }

            } catch (error) {
                console.error('Google Reviews fetch error:', error);
            } finally {
                this.loading = false;
            }
        },
    }
};
</script>
